export default "__VITE_ASSET__28WizhaR__"